import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { renameWorkspace } from 'src/store/workspaces/workspaces/actions';
import { WorkspaceInputStyled } from '../../../styles';
import { TabService } from 'src/api/services/workspaces/Service.tab';
import '../../../styles.css';

const WorkspaceTabTextbox = ({ workspace }) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const tabService = new TabService();

  useEffect(() => {
    if (!workspace.isActive)  setIsEditing(false);
  }, [workspace.isActive]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select(); 
    }
  }, [isEditing]);

  const toggleEditing = () => { if (workspace.isActive) setIsEditing(true);};

  const handleDivBlur = async () => {
    if (workspace.name.trim() === '') dispatch(renameWorkspace('New Tab'));
    await tabService.setTab(workspace, null);
    setIsEditing(false);
  };

  const handleKeyPress = (e) => { if (e.key === 'Enter') handleDivBlur();};

  return (
    <div onFocus={toggleEditing} onBlur={workspace.isActive ? handleDivBlur : null} title={workspace.name}>
      {isEditing && workspace.isActive ? (
        <WorkspaceInputStyled
          ref={inputRef}
          value={workspace.name}
          onKeyPress={handleKeyPress}
          onChange={(e) => { dispatch(renameWorkspace(e.target.value));}}
          className="workspace-button-input"
          style={{ width: isEditing ? `${(workspace.name.length + 4) * 7}px` : null }}
          inputlength={workspace.name.length}
          editing={isEditing.toString()}
        />
      ) : (
        <div onDoubleClick={toggleEditing}>{workspace.name}</div>
      )}
    </div>
  );
};

WorkspaceTabTextbox.propTypes = {
  activeWorkspaceIndex: PropTypes.number,
  workspace: PropTypes.object,
  index: PropTypes.number,
};

export default WorkspaceTabTextbox;
